import { MODULE_ID } from './constants';
export const DOWNLOAD_PDFS = `${MODULE_ID}/DOWNLOAD_PDFS`;
export const DOWNLOAD_PDFS_SUCCESS = `${MODULE_ID}/DOWNLOAD_PDFS_SUCCESS`;
export const DOWNLOAD_PDFS_ERROR = `${MODULE_ID}/DOWNLOAD_PDFS_ERROR`;
